import Styles from 'components/Wizards/RetryWizard/RetryWizard.module.scss'
import cx from 'classnames'
import { AlmanacFile } from 'types'
import { Button } from 'components/Button'
import { YoutubeScriptWizardProps, InitialValues } from 'components/Wizards/YoutubeScriptWizard/Types'
import { YoutubeScriptWizard } from 'components/Wizards/YoutubeScriptWizard/YoutubeScriptWizard'
import { GenerateNewDocButton } from './GenerateNewDocButton'

interface Props
  extends Omit<
    YoutubeScriptWizardProps,
    | 'initialValues'
    | 'articleId'
    | 'layerId'
    | 'nodeSelection'
    | 'bodyClassName'
    | 'stepperVariant'
    | 'headerClassName'
    | 'BlogPostWizardProps'
  > {
  articleId: string
  layerId: string
  initialValues: {
    project: AlmanacFile
  } & Partial<InitialValues>
}

export const RetryYoutubeScriptWizard = ({ initialValues, onSuccess, ...props }: Props) => {
  return (
    <YoutubeScriptWizard {...props} initialValues={initialValues}>
      {({ submitForm, isSubmitting }) => (
        <div className={cx(Styles.buttonContainer, Styles.rightButtons)}>
          <GenerateNewDocButton onSubmit={submitForm} project={initialValues.project} isDisabled={isSubmitting} />
          <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting}>
            Try Again on This Doc
          </Button>
        </div>
      )}
    </YoutubeScriptWizard>
  )
}
